import { useState, useRef, useEffect } from "react";
import s from "./portfolioCard.module.scss";
import { useTranslation } from "react-i18next";

const handleDragStart = (e) => e.preventDefault();

const GameFrame = ({ url, title, body, img }) => {
  const iframeRef = useRef();
  const [fullScreen, setFullScreen] = useState(false);
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const launchGame = () => {
    if (iframeRef.current) {
      if (iframeRef.current.requestFullscreen) {
        iframeRef.current.requestFullscreen();
      } else if (iframeRef.current.webkitRequestFullscreen) {
        iframeRef.current.webkitRequestFullscreen(); // Safari
      } else if (iframeRef.current.msRequestFullscreen) {
        iframeRef.current.msRequestFullscreen(); // IE/Edge
      }
    }
  };
  useEffect(() => {
    const fullscreenHandler = () => {
      if (document.fullscreenElement) {
        setFullScreen(true);
      } else {
        setFullScreen(false);
      }
    };
    document.addEventListener("fullscreenchange", fullscreenHandler);
    return () => {
      document.removeEventListener("fullscreenchange", fullscreenHandler);
    };
  }, []);
  return (
    <>
      <div
        className={s.game}
        onClick={launchGame}
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className={isMobile ? `${s.info} ${s.mobile_info}` : s.info}>
          <h6>{title}</h6>
          <p>{body}</p>
        </div>
      </div>
      <iframe
        title={url}
        ref={iframeRef}
        frameborder="0"
        src={url}
        style={{ display: fullScreen ? "unset" : "none" }}
        allowFullScreen
        loading="lazy"
      ></iframe>
    </>
  );
};

export const PortfolioCard = ({
  url,
  img,
  title_en,
  title_ru,
  body_en,
  body_ru,
  is_game,
}) => {
  const { i18n } = useTranslation();
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  return (
    <div className={s.card} onDragStart={handleDragStart}>
      {!!is_game ? (
        <GameFrame
          url={url}
          img={img}
          title={i18n.resolvedLanguage === "en" ? title_en : title_ru}
          body={i18n.resolvedLanguage === "en" ? body_en : body_ru}
        />
      ) : (
        <a
          style={{ backgroundImage: `url(${img})` }}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={isMobile ? `${s.info} ${s.mobile_info}` : s.info}>
            <h6>{i18n.resolvedLanguage === "en" ? title_en : title_ru}</h6>
            <p>{i18n.resolvedLanguage === "en" ? body_en : body_ru}</p>
          </div>
        </a>
      )}
    </div>
  );
};
